module.exports = __webpack_public_path__ + "static/media/img5.63fa5ce7.jpg";